import { createContext } from '@/utils';
import type { PromptState } from './types';

export const MagicPromptContext = createContext<PromptState | undefined>(
  undefined,
  'MagicPromptContext'
);
